import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-20 min-h-[60vh] text-center px-4 bg-background-50">
      <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className="ri-error-warning-line text-3xl"></i>
      </div>
      <h1 className="mt-6 text-2xl md:text-3xl font-heading font-semibold text-foreground-950">页面未找到</h1>
      <p className="mt-2 text-sm text-foreground-500">抱歉，您访问的页面不存在或已被移除</p>
      <Link
        to="/"
        className="mt-6 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-line mr-2"></i>
        返回首页
      </Link>
    </div>
  );
}